"use client";

import React from "react";
import { Linkedin, Instagram, MapPin, MessageCircle, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="230173" className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const phone = "(605) 910-4836";
  const whatsappNumber = phone.replace(/\D/g, "");
  return <section id="footer" className="bg-background text-foreground pt-16 pb-8 md:pt-24 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646044/img/rapid_tech_works_logo.png" alt="Rapid Tech Works Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Your local IT partners in Rapid City. We come alongside businesses to provide proactive monitoring, cybersecurity, and infrastructure that works.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold mb-6 text-secondary">Quick Links</h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold mb-6 text-secondary">Contact Us</h3>
            <ul className="space-y-4 text-sm text-muted-foreground mb-6">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>Rapid City<br />South Dakota, USA</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 text-primary shrink-0" />
                <span>{phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 text-primary shrink-0" />
                <span>info@rapidtechworks.com</span>
              </li>
            </ul>
            <Button variant="outline" className="w-full sm:w-auto border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all rounded-full" asChild>
              <Link to={`https://wa.me/${whatsappNumber}`} newTab>
                <MessageCircle className="mr-2 size-4" />
                Chat With Us
              </Link>
            </Button>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold mb-6 text-secondary">Follow Us</h3>
            <p className="text-sm text-muted-foreground mb-6">
              Stay connected for the latest IT tips and local business technology updates.
            </p>
            <div className="flex items-center gap-4">
              <Link to="#" className="flex size-10 items-center justify-center rounded-full border border-border bg-card shadow-sm hover:border-primary hover:bg-accent transition-all group" aria-label="LinkedIn">
                <Linkedin className="size-5 text-secondary group-hover:text-primary group-hover:scale-110 transition-transform" />
              </Link>
              <Link to="#" className="flex size-10 items-center justify-center rounded-full border border-border bg-card shadow-sm hover:border-primary hover:bg-accent transition-all group" aria-label="Instagram">
                <Instagram className="size-5 text-secondary group-hover:text-primary group-hover:scale-110 transition-transform" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="mb-8 opacity-50" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <p className="text-muted-foreground">
            &copy; {currentYear} RAPID TECH WORKS. All rights reserved.
          </p>
          <p className="font-mono text-primary font-semibold tracking-tight">
            Passionate People. Better IT.
          </p>
        </div>
      </div>
    </section>;
}